import { render, staticRenderFns } from "./OrderStatusComponent.vue?vue&type=template&id=2d3bd6f6&"
import script from "./OrderStatusComponent.vue?vue&type=script&lang=js&"
export * from "./OrderStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports